import React from 'react';
import './RaritySelector.css';

const SortSelector = ({ searchParams, handleSortChange }) => {
    return (
        <div className="alt-filter-row">
            <div className="alt-filter-label">Sort by:</div>
            <div className="alt-filter-select-container">
                <select
                    className="alt-filter-select"
                    value={searchParams.sort}
                    onChange={handleSortChange}
                    disabled={!searchParams.game}
                >
                    <option value="name-asc">Name (A-Z)</option>
                    <option value="name-desc">Name (Z-A)</option>
                    <option value="price-asc">Price (Low-High)</option>
                    <option value="price-desc">Price (High-Low)</option>
                </select>
                <div className="alt-select-arrow"></div>
            </div>
        </div>
    );
};

export default SortSelector;
